// extracted by mini-css-extract-plugin
export default {"submitSample__title":"SubmitSample_submitSample__title__pq-eC","submitSample__separator":"SubmitSample_submitSample__separator__GZJwS"};